import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import {
  createRule,
  deleteRule,
  listDecisionLogs,
  listRules,
  updateRule,
} from './api';
import { GeoRuleInput } from './types';

export const geoRulesQueryKey = ['geo-rules'] as const;

export const geoDecisionLogsQueryKey = (page: number, perPage: number) =>
  ['geo-decision-logs', page, perPage] as const;

export function useGeoRules() {
  return useQuery({
    queryKey: geoRulesQueryKey,
    queryFn: listRules,
  });
}

export function useGeoDecisionLogs(page: number, perPage: number) {
  return useQuery({
    queryKey: geoDecisionLogsQueryKey(page, perPage),
    queryFn: () => listDecisionLogs(page, perPage),
    placeholderData: keepPreviousData,
  });
}

export function useCreateRuleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: GeoRuleInput) => createRule(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: geoRulesQueryKey });
    },
  });
}

export function useUpdateRuleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: number; input: GeoRuleInput }) =>
      updateRule(id, input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: geoRulesQueryKey });
    },
  });
}

export function useDeleteRuleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteRule(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: geoRulesQueryKey });
    },
  });
}
